"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.bulkUpload.files.successProcessing': 'Your {count} file(s) will be processed in the background and added to your knowledge base.',
    'knowledge.bulkUpload.files.partialSuccess': '{successCount} file(s) will be processed in the background, {errorCount} failed.',
    'knowledge.bulkUpload.files.allFailed': 'Failed to upload all {count} file(s).',
    'knowledge.bulkUpload.googleDrive.successProcessing': 'Google Drive directory "{directoryName}" will be processed in the background and added to your knowledge base.',
};
